"use client";

import logger from "@/libs/utils/logging/logger";
import { useEffect } from "react";

/**
 * In production, this client component redirects users from the v2 app
 * to the legacy login page on app.respondology.io.
 *
 * This runs only in the browser so we avoid cross-origin redirects
 * during server component / RSC fetches.
 */
export function LegacyLoginRedirect({ v2Logout }: { v2Logout: boolean }) {
  useEffect(() => {
    try {
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith("moderate-sidebar-") || key.startsWith("discover-sidebar-")) {
          localStorage.removeItem(key);
        }
      });
    } catch (err) {
      logger.error({ err }, "Failed to clean up localStorage on legacy login redirect");
    }
    // v2_logout=true makes the legacy app call /users/me/log_out, which rotates the auth token on
    // every device — only forward it for an explicit logout, never for a failed session check.
    window.location.href = v2Logout
      ? "https://app.respondology.io/session/login?v2_logout=true"
      : "https://app.respondology.io/session/login";
  }, [v2Logout]);

  return null;
}
